import { forwardRef } from 'react';
import Cancel from '@mui/icons-material/Cancel';
import { Chip } from './Chip';
import type { ChipColor, ChipSize } from './Chip';
import { ChipAddon } from './ChipAddon';

export type InputChipProps = {
  size?: ChipSize;
  color?: ChipColor;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
};

export const InputChip = forwardRef<HTMLButtonElement, InputChipProps>(function ForwardedInputChip(
  {
    size = 'md',
    color = 'gray',
    disabled = false,
    onClick = () => {},
    className,
    children,
    ...rest
  }: InputChipProps,
  ref
) {
  return (
    <Chip
      {...rest}
      size={size}
      color={color}
      disabled={disabled}
      onClick={onClick}
      className={className}
      ref={ref}
    >
      {children}
      <ChipAddon>
        <Cancel />
      </ChipAddon>
    </Chip>
  );
});
